import {
	ClientFeatures,
	ClientFeatureOptions,
	Product,
	ProductEnum,
} from '@uc/web/shared/data-models';
import { ClientValidatorService } from '@uc/web/core';
import { CLE_UNI_SEARCH_SLUG } from '@uc/web/shared/data-access';
export class RedirectToUtils {
	cvSrv = new ClientValidatorService();

	postExclusive = [ClientFeatures.PostgraduateLandingPage];

	/**
	 * checks weather the client is postgraduate exclusive or paid postgraduate only
	 * @param paidFeatures the paid features from the API
	 * @param subdirectory subdirectories available under the university profile
	 * @param product undergraduate || postgraduate
	 * @return string: undergraduate || postgraduate
	 */
	navigate(
		paidFeatures: ClientFeatureOptions[],
		subdirectory: string,
		product: Product,
	): string {
		if (
			this.cvSrv.checkFeature(paidFeatures, this.postExclusive) ||
			(this.cvSrv.isPostgraduateOnly(paidFeatures) &&
				subdirectory !== 'undergraduate')
		) {
			return 'postgraduate';
		}

		if (product === ProductEnum.Clearing) return CLE_UNI_SEARCH_SLUG;
		return product;
	}
}
